(() => {
  const button = document.querySelector('[data-menu-button]');
  const menu = document.querySelector('[data-menu]');
  if (!button || !menu) return;

  const closeMenu = () => {
    button.setAttribute('aria-expanded', 'false');
    menu.classList.remove('open');
    menu.querySelectorAll('[data-submenu-button]').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.closest('.has-submenu')?.classList.remove('submenu-open');
    });
  };

  menu.querySelectorAll('.has-submenu').forEach((item) => {
    const toggle = item.querySelector('[data-submenu-button]');
    if (!toggle) return;
    const setOpen = (open) => {
      toggle.setAttribute('aria-expanded', String(open));
      item.classList.toggle('submenu-open', open);
    };
    item.addEventListener('mouseenter', () => setOpen(true));
    item.addEventListener('mouseleave', () => {
      if (!item.contains(document.activeElement)) setOpen(false);
    });
    item.addEventListener('focusin', () => setOpen(true));
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) setOpen(false);
    });
  });

  button.addEventListener('click', () => {
    const isOpen = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!isOpen));
    menu.classList.toggle('open', !isOpen);
  });

  menu.addEventListener('click', (event) => {
    const submenuButton = event.target.closest('[data-submenu-button]');
    if (submenuButton) {
      const isOpen = submenuButton.getAttribute('aria-expanded') === 'true';
      submenuButton.setAttribute('aria-expanded', String(!isOpen));
      submenuButton.closest('.has-submenu')?.classList.toggle('submenu-open', !isOpen);
      return;
    }
    if (event.target.closest('a')) closeMenu();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
      closeMenu();
      button.focus();
    }
  });

  document.addEventListener('click', (event) => {
    if (!button.contains(event.target) && !menu.contains(event.target)) closeMenu();
  });
})();

document.querySelectorAll('[data-presentation-slider]').forEach((slider) => {
  const slides = Array.from(slider.querySelectorAll('[data-presentation-slide]'));
  const dots = Array.from(slider.querySelectorAll('[data-slide-index]'));
  if (slides.length < 2) return;

  let activeIndex = 0;
  const showSlide = (nextIndex) => {
    activeIndex = (nextIndex + slides.length) % slides.length;
    slides.forEach((slide, index) => {
      const isActive = index === activeIndex;
      slide.hidden = !isActive;
      slide.classList.toggle('is-active', isActive);
    });
    dots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', String(isActive));
    });
  };

  slider.querySelector('[data-slide-previous]')?.addEventListener('click', () => showSlide(activeIndex - 1));
  slider.querySelector('[data-slide-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
  dots.forEach((dot) => {
    dot.addEventListener('click', () => showSlide(Number(dot.dataset.slideIndex)));
  });
  slider.addEventListener('keydown', (event) => {
    if (!event.target.matches('button')) return;
    if (event.key === 'ArrowLeft') showSlide(activeIndex - 1);
    if (event.key === 'ArrowRight') showSlide(activeIndex + 1);
  });
});

/* Product variant selection updates one image, price and availability in place. */
document.querySelectorAll('[data-product-section]').forEach((section) => {
  const dataNode = section.querySelector('[data-product-variants]');
  const form = section.querySelector('form.product-form');
  if (!dataNode || !form) return;
  let variants;
  try { variants = JSON.parse(dataNode.textContent); } catch { return; }
  const optionSelects = Array.from(form.querySelectorAll('[data-option-index]'));
  const variantInput = form.querySelector('[data-variant-id]');
  const priceNode = section.querySelector('[data-variant-price]');
  const compareNode = section.querySelector('[data-variant-compare]');
  const addButton = form.querySelector('[data-add-to-cart]');
  const media = section.querySelector('[data-product-media]');
  const image = media?.querySelector('img');
  if (!variants.length || !variantInput || !addButton) return;

  const updateSelection = () => {
    const selectedOptions = optionSelects.map((select) => select.value);
    const variant = variants.find((item) => item.options.every((value, index) => value === selectedOptions[index]));
    if (!variant) {
      variantInput.value = '';
      addButton.disabled = true;
      addButton.textContent = 'Combinaison indisponible';
      return;
    }

    variantInput.value = variant.id;
    addButton.disabled = !variant.available;
    addButton.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
    if (priceNode && variant.price) priceNode.textContent = variant.price;
    if (compareNode) {
      compareNode.textContent = variant.compareAt || '';
      compareNode.hidden = !variant.compareAt;
    }
    if (image && variant.image && media.dataset.currentImage !== variant.image) {
      media.classList.add('is-changing');
      image.addEventListener('load', () => media.classList.remove('is-changing'), { once: true });
      image.addEventListener('error', () => media.classList.remove('is-changing'), { once: true });
      image.removeAttribute('srcset');
      image.src = variant.image;
      media.dataset.currentImage = variant.image;
      image.alt = `${section.querySelector('h1')?.textContent || 'Produit'} — ${selectedOptions.join(' · ')}`;
    }
    if (window.history?.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  };
  optionSelects.forEach((select) => select.addEventListener('change', updateSelection));
});